const fields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'imei',
    label: 'report.fields.imei',
    header: 'imei',
    filter: false,
    width: 20,
  },
  {
    key: 'deviceType',
    label: 'report.fields.deviceType',
    header: 'deviceType',
    filter: false,
    width: 20,
  },
  {
    key: 'driver',
    label: 'global.object.driver',
    header: 'driver',
    filter: false,
    width: 20,
  },
  {
    key: 'startTime',
    label: 'report.fields.startTime',
    header: 'startTime',
    disabled: true,
    filter: false,
    width: 20,
  },
  {
    key: 'startLocation',
    label: 'report.fields.startLocation',
    header: 'startLocation',
    filter: false,
    width: 30,
  },
  {
    key: 'stopTime',
    label: 'report.fields.endTime',
    header: 'stopTime',
    disabled: true,
    filter: false,
    width: 20,
  },
  {
    key: 'stopLocation',
    label: 'report.fields.endLocation',
    header: 'stopLocation',
    filter: false,
    width: 30,
  },
  {
    key: 'offlineDuration',
    label: 'report.fields.offlineDuration',
    header: 'offlineDuration',
    filter: false,
    width: 30,
  },
]
export default fields
